export interface CardDetailRedactionViewer {
  isInExplicitOrg: boolean
  organizationId?: string
}

export interface CardDetailRedactionSender {
  organizationId?: string
}

// Redact whenever an organization id needed for the decision is missing: the
// embedded cardholder can omit it, and undefined === undefined would otherwise
// read as "same org".
export const shouldHideCardDetails = (
  viewer: CardDetailRedactionViewer | undefined,
  sender: CardDetailRedactionSender | undefined,
): boolean => {
  if (viewer?.isInExplicitOrg === true) return false
  return (
    viewer?.organizationId === undefined ||
    sender?.organizationId === undefined ||
    viewer.organizationId !== sender.organizationId
  )
}
